import Auth, { FetchAPI, ParamsSerializer } from './auth-service';
import { SaveFileFromAPI } from '../libraries/helpers';

import Moment from 'moment';

const Fields = [
    {
        variable: 'user',
        title: 'User',
        field: 'user',
        type: 'string',
    },
    {
        variable: 'created',
        title: 'Created',
        field: 'created',
        type: 'dateTime',
    },
    {
        variable: 'finished',
        title: 'Finished',
        field: 'finished',
        type: 'dateTime',
    },
    {
        variable: 'sensor',
        title: 'Sensor',
        field: 'host',
        type: 'string',
    },
    {
        variable: 'range',
        title: 'Range',
        field: 'timerange',
        type: 'string',
    },
    {
        variable: 'size',
        title: 'Size',
        field: 'size',
        type: 'string',
    },
    {
        variable: 'query',
        title: 'Query',
        field: 'query',
        type: 'string',
    },
    {
        variable: 'progress',
        title: 'Progress',
        field: 'progress',
        type: 'number',
    },
    {
        variable: 'queue',
        title: 'Queue',
        field: 'wait',
        type: 'string',
    },
    {
        variable: 'state',
        title: 'State',
        field: 'state',
        type: 'string',
    },
];

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

class PcapDataService {
    constructor () {
        // we only need one of these
        if (!PcapDataService.instance) {
            PcapDataService.instance = this;
        }

        this.searchPlaceholder = 'Search packet capture requests';

        this.list = (cmc) => {
            if (MC2CHECK && !cmc) return Promise.reject(new Error('no cmc'));
            const prefix = MC2CHECK ? `mc2/cmcapi/${cmc.name}/` : '';

            return FetchAPI({
                method: 'GET',
                url: `${prefix}pcap_v2/`,
            });
        };

        this.download = (host, id, file, cmc) => {
            if (MC2CHECK && !cmc) return Promise.reject(new Error('no cmc'));
            const prefix = MC2CHECK ? `mc2/cmcapi/file/${cmc.name}/` : '';

            const auth = Auth.getAuth();
            const token = auth ? auth.token : '';
            const params = {
                t: token,
                filename: file
            };
            console.log(`/api/${prefix}pcap_v2/${encodeURIComponent(host)}/${encodeURIComponent(id)}/-download`);
            SaveFileFromAPI(`/api/${prefix}pcap_v2/${encodeURIComponent(host)}/${encodeURIComponent(id)}/-download`, params);
        };

        this.cancel = (host, id, cmc) => {
            if (MC2CHECK && !cmc) return Promise.reject(new Error('no cmc'));
            const prefix = MC2CHECK ? `mc2/cmcapi/${cmc.name}/` : '';

            return FetchAPI({
                method: 'DELETE',
                url: `${prefix}pcap_v2/${encodeURIComponent(host)}/${encodeURIComponent(id)}`
            });
        };

        this.query = (host, id, cmc) => {
            if (MC2CHECK && !cmc) return Promise.reject(new Error('no cmc'));
            const prefix = MC2CHECK ? `mc2/cmcapi/${cmc.name}/` : '';

            return FetchAPI({
                method: 'GET',
                url: `${prefix}pcap_v2/${encodeURIComponent(host)}/${encodeURIComponent(id)}`
            });
        };

        this.create = (host, data, cmc) => {
            if (MC2CHECK && !cmc) return Promise.reject(new Error('no cmc'));
            const prefix = MC2CHECK ? `mc2/cmcapi/${cmc.name}/` : '';

            return FetchAPI({
                method: 'POST',
                url: `${prefix}pcap_v2/${encodeURIComponent(host)}/?${ParamsSerializer(data)}`
            });
        };

        this.compliantProtocols = ['tcp', 'udp', 'icmp', 'ipv6-icmp'];

        this.alert2filter = (alert) => ({
            sensor: alert.data.bricata.sensor_uuid,
            uuid: alert.uuid,
            timestamp: Moment(alert.timestamp).unix(),
            ogTimestamp: alert.timestamp,
            proto: alert.data.proto.toLowerCase(),
            src: alert.data.src_ip,
            dst: alert.data.dest_ip,
            sport: alert.data.src_port ? alert.data.src_port.toString() : '',
            dport: alert.data.dest_port ? alert.data.dest_port.toString() : ''
        });

        this.mtdt2filter = mtdt => {
            var req = {
                sensor: mtdt._source.bricata.sensor_uuid,
                uuid: mtdt._source.bro_log.uid,
                timestamp: Moment(mtdt._source.timestamp).unix(),
                ogTimestamp: mtdt._source.timestamp,
                proto: mtdt._source.bro_log.proto.toLowerCase(),
                src: mtdt._source.bro_log['id.orig_h'],
                dst: mtdt._source.bro_log['id.resp_h'],
                sport: (mtdt._source.bro_log['id.orig_p'] || '').toString(),
                dport: (mtdt._source.bro_log['id.resp_p'] || '').toString()
            };
            if ((req.proto || '').toLowerCase() === 'icmp') {
                if (req.src.includes(':')) req.proto = 'ipv6-icmp';
                req.sport = '';
                req.dport = '';
            }
            return req;
        };

        return PcapDataService.instance;
    }
}

const PcapService = new PcapDataService();

export {
    PcapService as default,
    Fields
};
